import { Component, OnInit, AfterViewInit } from '@angular/core';

import {
  Errors,
  LocalService,
  ManagerService,
  StoreService,
} from '../../core';
import { TabItem } from '../../shared/components/tabs/tabs.component';

@Component({
  selector: 'app-manage-claims',
  templateUrl: './manage-claims.component.html',
  styleUrls: ['./manage-claims.component.scss'],
})
export class ManageClaimsComponent implements OnInit, AfterViewInit {

  defaultTab = 1;
  activeTabId = 'tab-1';
  claimsTabs: TabItem[] = [];
  errors: Errors = { errors: {} };
  userProfile: any;
  region = '';
  isClaimByPo = false;
  isSalesChallenge = false;
  isActivityChallenge = false;
  isChallengePreference = false;
  isSalesEngineerRole: Boolean = true;
  isSalesChallengeUser = false;
  isActivityChallengeUser = false;
  isClaimerAdmin: Boolean = false;
  isQuickClaim: Boolean = false;
  isPOPkClaim: Boolean = false;
  showManageClaimsTab = true;

  constructor(
    private managerService: ManagerService,
    private storeService: StoreService
  ) { }

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.region = this.userProfile.company.region;
    this.checkSalesEngineerRole();
    this.getUserPreferences(6);
    this.getUserPreferences(7);

    this.buildClaimsTabs();
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  buildClaimsTabs() {
    this.claimsTabs = [
      {
        id: 'tab-1',
        label: 'Sales Challenge Claims',
        isVisible:
          this.isSalesChallenge &&
          !this.isClaimByPo &&
          this.isSalesChallengeUser &&
          this.isChallengePreference &&
          this.showManageClaimsTab,
      },
      {
        id: 'tab-2',
        label: 'Sales Challenge Claims',
        isVisible: this.isSalesChallenge && this.isClaimByPo && this.showManageClaimsTab,
      },
      {
        id: 'tab-0',
        label: 'Activity Challenge Claims',
        isVisible: this.isActivityChallenge && this.isActivityChallengeUser,
      },
      {
        id: 'tab-3',
        label: 'Claimed Earnings',
        isVisible: this.showManageClaimsTab,
      },
    ];
    this.activeTabId = 'tab-' + this.defaultTab;
  }

  onTabChange(tab: TabItem) {
    const tabIndex = parseInt(tab.id.split('-')[1], 10);
    this.defaultTab = tabIndex;
    this.setTab(tabIndex);
  }

  setTab(index: number) {
    this.defaultTab = index;
    this.activeTabId = 'tab-' + index;
  }

  getUserPreferences(id: number) {
    const params = {
      userId: this.userProfile.id,
      preferenceId: id,
    };
    this.managerService.getUserPreferences(params).subscribe(
      (data: any) => {
        if (id === 6) {
          this.isSalesChallengeUser = data.enabled;
        }
        if (id === 7) {
          this.isActivityChallengeUser = data.enabled;
        }
        this.getCompanyPreferences();

      },
      (err: any) => {
        this.errors = err;
      }
    );
  }

  checkSalesEngineerRole() {
    this.isSalesEngineerRole = this.userProfile.roles.find(
      (item: any) => item.name === 'SALES_ENGINEER'
    );
  }

  getCompanyPreferences() {
    if (this.userProfile.company && this.userProfile.company.id) {
      const companyParams = {
        companyId: this.userProfile.company.id,
      };
      this.managerService.getCompanyPreferences(companyParams).subscribe(
        (data: any) => {
          const preference = data.companyPreferences.find(
            (item: any) => item.name === 'COMPANY_SALES_CHALLENGES_AND_REWARDS'
          );
          if (preference) {
            this.isChallengePreference = preference.enabled;
          }
          const preferences = data.companyPreferences.map(
            (item: any) => item.enabled
          );
          this.isSalesChallenge = preferences[0];
          this.isActivityChallenge = preferences[1];
          this.isClaimerAdmin = preferences[7];
          this.isQuickClaim = preferences[3];
          this.isPOPkClaim = preferences[4];
          this.isClaimByPo = false;

          const tabName = data.companyPreferences.find(
            (item: any) => item.name === 'COMPANY_CLAIMING_PO_NUMBER'
          );
          this.isClaimByPo = tabName.enabled;

          this.buildClaimsTabs();

          if (
            this.isSalesChallenge &&
            this.isChallengePreference &&
            this.isClaimByPo
          ) {
            this.defaultTab = 2;
          }
          if (
            this.isActivityChallenge &&
            this.isActivityChallengeUser &&
            (!this.isSalesChallenge ||
              !this.isSalesChallengeUser ||
              !this.isChallengePreference)
          ) {
            this.defaultTab = 0;
          }
          if (
            (!this.isActivityChallenge || !this.isActivityChallengeUser) &&
            (!this.isSalesChallenge ||
              !this.isSalesChallengeUser ||
              !this.isChallengePreference)
          ) {
            this.defaultTab = 3;
          }
          this.setTab(this.defaultTab);

          if (this.storeService.getPreviousRoute() !== null) {
            this.defaultTab = 0;
            this.setTab(this.defaultTab);
            this.storeService.setPreviousRoute('');
          }
        },
        (err: any) => {
          this.errors = err;
        }
      );
    }

  }
}
